import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { ProjectsService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class ProjectListBloc extends Bloc<ProjectsService['projectControllerGet']> {
    public constructor(service: ProjectsService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.projectControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
